import { Injectable } from '@angular/core';
import { SweetAlertHelper } from './sweet-alert-helper.service';
import { ExportResultEnum } from '../enums/data-export.enum';

@Injectable()
export class DataExportNotifierHelper {
  private readonly messages: { [result: number]: string } = {
    [ExportResultEnum.GridUnavailable]: 'The grid is not available to export',
    [ExportResultEnum.EmptySelection]: 'Please select at least one record',
  };

  constructor(private sweetAlertHelper: SweetAlertHelper) {}

  notify(result: ExportResultEnum): boolean {
    const message = this.messages[result];
    if (!message) {
      return true;
    }
    this.sweetAlertHelper.createCustomAlert({
      title: 'Info',
      text: message,
      type: 'info',
    });
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/data-export-notifier.helper.ts